export default {
  GET_REPORT_TYPE: (state) => state.report_type,
};
